(function () {
  if (window.__mpnSurfKeep) return; window.__mpnSurfKeep = true;
  var KEY = 'mpnSurfKeep', MAX_AGE = 30 * 60 * 1000;
  var st = null, busy = false, quietUntil = 0;

  function calc() { return document.querySelector('quantity-calculator'); }
  function pid(c) { var p = c && c.closest('product-info'); return p ? String(p.getAttribute('data-product-id') || '') : ''; }
  function cond(c) { var d = c && c.querySelector('#calculator-data'); return d ? String(d.getAttribute('data-conditionnement') || '') : ''; }
  function uv(c) { var d = c && c.querySelector('#calculator-data'); var v = parseFloat(d && d.getAttribute('data-unit-volume')); return v > 0 ? v : 1; }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(/\s/g, '').replace(',', '.')); return isNaN(n) ? null : n; }
  function r2(x) { return Math.round(x * 100) / 100; }
  function surfaceProduct(c) { var k = cond(c); return k === 'm2' || k === 'mL'; }
  function marginBox(c) { return c && c.querySelector('[data-mpn-margin]'); }
  function marginIdx(c) {
    var b = marginBox(c); if (!b) return -1;
    var r = b.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < r.length; i++) if (r[i].checked) return i;
    return -1;
  }
  /* marge actuellement appliquee sur la quantite (choix +15 / +30 %, ou ancienne case « marge de x % ») */
  function marginPct(c) {
    var b = marginBox(c);
    if (b) { var r = b.querySelector('input[type="radio"]:checked'); return r ? (num(r.value) || 0) : 0; }
    var cut = c && c.querySelector('#cuttings');
    return cut && cut.checked ? (num(cut.getAttribute('data-percent')) || 0) : 0;
  }

  function load() {
    try { var s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); return s && typeof s === 'object' ? s : null; } catch (e) { return null; }
  }
  function save() {
    if (!st) return;
    st.t = Date.now();
    try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
  }
  function record(src) {
    var c = calc(); if (!c || !surfaceProduct(c)) return;
    var p = pid(c); if (!p) return;
    if (src != null && !(src > 0)) return;
    if (src == null && !(st && st.pid === p)) return;
    st = { pid: p, cond: cond(c), src: src != null ? r2(src) : st.src, idx: marginIdx(c), cut: !!(c.querySelector('#cuttings') || {}).checked };
    save();
  }
  function blocked() { return busy || Date.now() < quietUntil; }

  /* ---------- memorisation : chaque saisie du client ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target, c = calc();
    if (!c || !t || !t.matches || !c.contains(t) || busy) return;
    /* choix de marge : toujours memorise */
    if (t.matches('#cuttings, [data-mpn-margin] input[type="radio"]')) { setTimeout(function () { if (!busy) record(null); }, 0); return; }
    if (blocked()) return;
    if (t.matches('.volume__input')) { record(num(t.value)); return; }
    if (t.matches('.quantity__input')) {
      /* quantite ecrite par un script (marge de pose, palettes : « input » puis « change ») : pas une saisie */
      if (t.__mpnKeepProg) { t.__mpnKeepProg = false; return; }
      var q = num(t.value); if (q == null) return;
      var single = !c.querySelector('.volume__input');
      /* case unique tapee au clavier : la valeur tapee est la surface (la marge s'applique ensuite dessus) */
      record(single && t.__mpnRelease ? q * uv(c) : q * uv(c) / (1 + marginPct(c) / 100));
    }
  });
  document.addEventListener('click', function (e) {
    var c = calc(), t = e.target;
    if (!c || !t || !t.closest || !c.contains(t)) return;
    /* fleches de la case surface : elles changent le nombre de lots */
    if (t.closest('quantity-volume .quantity__button')) {
      if (blocked()) return;
      setTimeout(function () {
        var q = num((c.querySelector('.quantity__input') || {}).value);
        if (q != null) record(q * uv(c) / (1 + marginPct(c) / 100));
      }, 0);
      return;
    }
    /* marge decochee en touchant le choix actif */
    if (t.closest('[data-mpn-margin] .mpn-margin__opt')) setTimeout(function () { if (!busy) record(null); }, 0);
  });

  /* ---------- reinjection apres changement de variante ---------- */
  function fire(el, type) { el.dispatchEvent(new Event(type, { bubbles: true })); }
  function restore(s) {
    var c = calc();
    if (!s || !c || !surfaceProduct(c) || s.pid !== pid(c) || s.cond !== cond(c) || !(s.src > 0)) return;
    var vol = c.querySelector('.volume__input'), q = c.querySelector('.quantity__input');
    if (!vol && !q) return;
    busy = true;
    try {
      if (vol) {
        /* comme une saisie du client dans « Surface a couvrir » : lots, palettes, total recalcules par le theme */
        vol.value = String(s.src);
        fire(vol, 'input'); fire(vol, 'change');
      } else {
        /* fiche vendue directement au m² / m : meme arrondi que la calculette « Calculer ma quantite » */
        var min = parseInt(q.min, 10) || 1, step = parseInt(q.step, 10) || 1;
        var v = Math.max(min, Math.ceil(s.src / uv(c) / step - 1e-9) * step);
        if (q.max) v = Math.min(v, parseInt(q.max, 10) || v);
        q.value = v;
        q.__mpnRelease = true;
        fire(q, 'input'); fire(q, 'change');
        q.__mpnRelease = false;
      }
    } catch (err) {}
    /* marge de pose : reappliquee juste apres, comme si le client la choisissait apres sa surface */
    setTimeout(function () {
      try {
        var b = marginBox(c);
        if (b && s.idx >= 0) {
          var r = b.querySelectorAll('input[type="radio"]')[s.idx];
          if (r && !r.checked && !r.disabled) { r.checked = true; fire(r, 'change'); }
        } else if (!b && s.cut) {
          var cut = c.querySelector('#cuttings');
          if (cut && !cut.checked) { cut.checked = true; fire(cut, 'change'); }
        }
      } catch (err) {}
      busy = false;
      st = { pid: s.pid, cond: s.cond, src: s.src, idx: s.idx, cut: s.cut };
      save();
    }, 0);
  }
  function onVariant() {
    prep();
    /* apres les abonnes du theme (reinitialisation du calculateur), avant tout affichage suivant */
    quietUntil = Date.now() + 1500;
    var s = st;
    setTimeout(function () { restore(s); quietUntil = Date.now() + 1200; }, 30);
  }

  /* ---------- saisie mobile ---------- */
  function clean(v) {
    var x = String(v == null ? '' : v).replace(/\s/g, '').replace(/,/g, '.').replace(/[^0-9.]/g, '');
    var i = x.indexOf('.');
    if (i > -1) x = x.slice(0, i + 1) + x.slice(i + 1).replace(/\./g, '');
    return x.replace(/\.$/, '');
  }
  /* claviers adaptes (le contenu du calculateur est remplace a chaque changement de variante) */
  function prep() {
    document.querySelectorAll('quantity-calculator').forEach(function (c) {
      var vol = c.querySelector('input.volume__input');
      if (vol && vol.type === 'number' && document.activeElement !== vol) {
        vol.type = 'text';
        vol.setAttribute('autocomplete', 'off');
        vol.setAttribute('autocorrect', 'off');
        vol.setAttribute('spellcheck', 'false');
        if (!vol.getAttribute('inputmode')) vol.setAttribute('inputmode', 'decimal');
        if (vol.getAttribute('inputmode') === 'numeric') vol.setAttribute('pattern', '[0-9]*');
      }
      var q = c.querySelector('input.quantity__input');
      if (q && !q.hasAttribute('pattern')) {
        q.setAttribute('inputmode', 'numeric');
        q.setAttribute('pattern', '[0-9]*');
        if (!q.getAttribute('enterkeyhint')) q.setAttribute('enterkeyhint', 'done');
      }
    });
  }
  /* avant tous les scripts de la fiche (phase de capture sur window) */
  window.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.closest || !t.closest('quantity-calculator')) return;
    if (t.matches('input.quantity__input')) {
      if (!e.isTrusted && !t.__mpnRelease && !busy) { t.__mpnKeepProg = true; setTimeout(function () { t.__mpnKeepProg = false; }, 0); }
      return;
    }
    if (!t.matches('input.volume__input')) return;
    if (e.isTrusted) {
      /* pendant la frappe : seuls chiffres, une virgule ou un point */
      var v = String(t.value), n = v.replace(/[^0-9.,]/g, '');
      var i = n.search(/[.,]/);
      if (i > -1) n = n.slice(0, i + 1) + n.slice(i + 1).replace(/[.,]/g, '');
      if (n !== v) { t.value = n; try { t.setSelectionRange(n.length, n.length); } catch (x) {} }
      t.__mpnKeepHold = false;
      return;
    }
    if (!t.__mpnRelease) return;
    /* fin de saisie envoyee au calcul du theme : « 1, » encore en cours -> on attend ; sinon 12,5 -> 12.5 */
    if (document.activeElement === t && /[.,]$/.test(String(t.value).trim())) {
      t.__mpnKeepHold = true;
      e.stopImmediatePropagation();
      return;
    }
    var c2 = clean(t.value);
    if (c2 !== '' && c2 !== String(t.value)) t.value = c2;
  }, true);
  window.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.__mpnKeepHold && !e.isTrusted && t.__mpnRelease) e.stopImmediatePropagation();
  }, true);
  /* a la sortie du champ seulement */
  document.addEventListener('focusout', function (e) {
    var t = e.target, c = calc();
    if (!c || !t || !t.matches || !c.contains(t)) return;
    setTimeout(function () {
      if (!t.isConnected || document.activeElement === t) return;
      if (t.matches('.volume__input')) {
        /* « 1, » laisse en attente : calcule maintenant, comme une fin de saisie */
        if (t.__mpnKeepHold) {
          t.__mpnKeepHold = false;
          var cv = clean(t.value);
          if (cv !== '') {
            t.value = cv;
            t.__mpnRelease = true;
            fire(t, 'input'); fire(t, 'change');
            t.__mpnRelease = false;
            return;
          }
        }
        if (num(t.value) == null && typeof c.updateVolume === 'function' && c.volumeInput === t) { try { c.updateVolume(); } catch (x) {} }
        return;
      }
      if (!t.matches('.quantity__input') || t.hasAttribute('data-mpn-moq')) return;
      var min = parseInt(t.getAttribute('min'), 10); if (!(min > 0)) min = 1;
      var step = parseInt(t.getAttribute('step'), 10); if (!(step > 0)) step = 1;
      var max = parseInt(t.getAttribute('max'), 10);
      var v = num(t.value), w = v;
      if (w == null || w < min) w = min;
      else if (Math.abs(w - Math.round(w)) > 1e-9 || (step > 1 && w % step)) w = Math.max(min, Math.ceil(w / step - 1e-9) * step);
      if (max > 0 && w > max) w = max;
      if (w === v && String(t.value) === String(v)) return;
      t.value = w;
      if (c.volumeInput && typeof c.updateVolume === 'function') { try { c.updateVolume(); } catch (x) {} }
      else if (typeof c.updatePrice === 'function') { try { c.updatePrice(w); } catch (x) {} }
      t.dispatchEvent(new CustomEvent('quantity:sync', { bubbles: true }));
    }, 0);
  });

  /* ---------- demarrage ---------- */
  var started = false;
  function start() {
    if (started) return; started = true;
    prep();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      try { subscribe(PUB_SUB_EVENTS.variantChange, onVariant); } catch (e) {}
    }
    var c = calc(), s = load();
    if (!c || !s || s.pid !== pid(c) || !(Date.now() - (s.t || 0) < MAX_AGE)) return;
    /* rechargement de la meme fiche vers une autre variante : la surface est reprise.
       Arrivee depuis ailleurs (collection, recherche...) : comportement normal, rien n'est repris. */
    var same = false;
    try { same = !!document.referrer && new URL(document.referrer).pathname === location.pathname; } catch (e) {}
    var nav = '';
    try { nav = (performance.getEntriesByType('navigation')[0] || {}).type || ''; } catch (e) {}
    if (!same && nav !== 'reload') return;
    st = s;
    setTimeout(function () { restore(s); }, 300);
  }
  /* champ remplace par un autre script avant d'etre touche : claviers remis juste avant le focus */
  window.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('quantity-calculator')) prep();
  }, true);
  prep();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
